import { useQuery } from '@tanstack/react-query';

import { featureSettings } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useEnableAmexIrAffiliate = () => {
  const query = useQuery({
    queryKey: [QueryKeys.ENABLE_AMEX_IR_AFFILIATE],
    queryFn: () => featureSettings.getEnableAmexIrAffiliate(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};
